export default "__VITE_ASSET__BBUFeTGS__"